module.exports = __webpack_public_path__ + "static/media/43_tn.7f481a38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/43_tn.jpg
// module id = 352
// module chunks = 0